import clsx from "clsx";
import dndCss from "../styles/dnd.module.css";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useEffect, useState } from "react";
import { ConnectDropTarget } from "react-dnd";
import { useDndStore } from "../store/dnd-store";

interface GlobalDropZoneProps {
	drop: ConnectDropTarget;
	handlerId: string;
}

export const GlobalDropZone: FunctionComponent<GlobalDropZoneProps> = observer(function GlobalDropZone({ drop, handlerId }) {
	const { isDragging } = useDndStore();
	const [isDraggingAndMounted, setIsDraggingAndMounted] = useState(false);
	// need to wait for mount to enable drop zone correctly
	useEffect(() => {
		setIsDraggingAndMounted(isDragging);
	}, [isDragging]);
	return (
		<div
			className={clsx(
				dndCss.globalDropZone,
				isDraggingAndMounted && dndCss.globalDropZoneActive,
			)}
			data-handler-id={handlerId}
			ref={drop}
		/>
	);
});